import React from "react";
import {
  Alert,
  AlertTitle,
  Box,
  Paper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const AlertDescription = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Description
        </Typography>

        <Typography variant="body1">
          You can use the AlertTitle component to display a formatted title
          above the content.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              '            <Alert severity="error">\n' +
              "              <AlertTitle>Error</AlertTitle>\n" +
              "              This is an error alert — <strong>check it out!</strong>\n" +
              "            </Alert>\n" +
              '            <Alert severity="warning">\n' +
              "              <AlertTitle>Warning</AlertTitle>\n" +
              "              This is a warning alert — <strong>check it out!</strong>\n" +
              "            </Alert>\n" +
              '            <Alert severity="info">\n' +
              "              <AlertTitle>Info</AlertTitle>\n" +
              "              This is an info alert — <strong>check it out!</strong>\n" +
              "            </Alert>\n" +
              '            <Alert severity="success">\n' +
              "              <AlertTitle>Success</AlertTitle>\n" +
              "              This is a success alert — <strong>check it out!</strong>\n" +
              "            </Alert>"
            }
          >
            <Stack direction={"column"} sx={{ width: "70%" }} spacing={2}>
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                This is an error alert — <strong>check it out!</strong>
              </Alert>
              <Alert severity="warning">
                <AlertTitle>Warning</AlertTitle>
                This is a warning alert — <strong>check it out!</strong>
              </Alert>
              <Alert severity="info">
                <AlertTitle>Info</AlertTitle>
                This is an info alert — <strong>check it out!</strong>
              </Alert>
              <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                This is a success alert — <strong>check it out!</strong>
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default AlertDescription;
